import React from 'react';
import { InfoOutlined, LocalShippingOutlined, StorageOutlined } from "@mui/icons-material";
import { Box, Chip, Grid, Popover, Tooltip, Typography } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { useLegDetailContext } from "contexts/LegDetailContext";

const LegBasicDetail = () => {

  const { legDetail, loadingLeg } = useLegDetailContext();

  const shipments = Array.isArray(legDetail?.shipmentId)
    ? legDetail.shipmentId
    : [];

  const visibleShipments = shipments.slice(0, 2);
  const remainingCount = shipments.length - visibleShipments.length;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleChipClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return !loadingLeg ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Shipment Requests ID"
            subtitle={
              shipments.length > 0 ? (
                <Box display="flex" alignItems="center" flexWrap="wrap" gap={0.5}>
                  {visibleShipments.map((el, idx) => (
                    <span key={idx} style={{ fontSize: "0.9rem" }}>
                      {el?.shipmentId}
                      {idx !== visibleShipments.length - 1 && ","}
                    </span>
                  ))}
                  {remainingCount > 0 && (
                    <Tooltip title="Click to view all Shipment IDs">
                      <Chip
                        label={`+${remainingCount}`}
                        size="small"
                        sx={{
                          marginLeft: "4px",
                          height: "18px",
                          fontSize: "10px",
                          backgroundColor: "#e0e0e0",
                          color: "#333",
                          cursor: "pointer",
                        }}
                        onClick={handleChipClick}
                      />
                    </Tooltip>
                  )}
                </Box>
              ) : (
                "N/A"
              )
            }
          />
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <Box p={2} minWidth={100}>
              {shipments.map((el, idx) => (
                <Typography key={idx} variant="body2" sx={{ wordBreak: "break-word" }}>
                  {el?.shipmentId}
                </Typography>
              ))}
            </Box>
          </Popover>
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Leg ID"
            subtitle={legDetail?.legId}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <StorageOutlined color="primary" />}
            title="Source Branch ID"
            subtitle={
              typeof legDetail?.sourceBranch === "object"
                ? legDetail?.sourceBranch?.name
                : legDetail?.sourceBranch
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <StorageOutlined color="primary" />}
            title="Destination Branch ID"
            subtitle={
              typeof legDetail?.destinationBranch === "object"
                ? legDetail?.destinationBranch?.name
                : legDetail?.destinationBranch
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="isActive"
          >
            <Status isActive={legDetail?.isActive} />
          </InformationTile>
        </Grid>

      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default LegBasicDetail;
